// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from '../../types/supabase';

const SUPABASE_URL = "https://hktaykyxtwhbebmcmkns.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhrdGF5a3l4dHdoYmVibWNta25zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU4NTE1MzYsImV4cCI6MjA2MTQyNzUzNn0.1EyuCyVYazvBZUO4AvKlmjQY9ZMNcqtswdVgbfFy6EY";

// Configuración adicional para el cliente
const supabaseOptions = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
};

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  supabaseOptions
);
